<script>
export default {
  name: "ReportAccountStatusDocumentType",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];

    if (val === "Invoice") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--dark",
          style: "color:white;"
        },
        "Factura"
      );
    }
    if (val == "Credit Memo") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--dark",
          style: "color:white;"
        },
        "Nota de crédito"
      );
    }
    if (val == "Payment") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--info el-tag--dark",
          style: "color:white;"
        },
        "Pago"
      );
    }

    return createElement("");
  }
};
</script>
